import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div>
      <div className="site-primary" id="main">
        <div className="site-content" id="content">
          <div
            data-elementor-type="wp-page"
            data-elementor-id={4871}
            className="elementor elementor-4871"
          >
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-0dc37f8 elementor-section-height-min-height elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
              data-id="0dc37f8"
              data-element_type="section"
              data-settings='{"background_background":"classic","_ha_eqh_enable":false}'
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-465ff08"
                  data-id="465ff08"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-c3aefb2 elementor-widget elementor-widget-heading"
                      data-id="c3aefb2"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <style
                          dangerouslySetInnerHTML={{
                            __html:
                              "\n\t\t\t\t\t\t\t\t\t\t\t\t/*! elementor - v3.22.0 - 26-06-2024 */\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-heading-title {\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\tline-height: 1\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-heading .elementor-heading-title[class*=elementor-size-]>a {\n\t\t\t\t\t\t\t\t\t\t\t\t\tcolor: inherit;\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: inherit;\n\t\t\t\t\t\t\t\t\t\t\t\t\tline-height: inherit\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-heading .elementor-heading-title.elementor-size-small {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 15px\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-heading .elementor-heading-title.elementor-size-medium {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 19px\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-heading .elementor-heading-title.elementor-size-large {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 29px\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-heading .elementor-heading-title.elementor-size-xl {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 39px\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t.elementor-widget-heading .elementor-heading-title.elementor-size-xxl {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 59px\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t"
                          }}
                        />
                        <h2 className="elementor-heading-title elementor-size-default">
                          Privacy Policy
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-4220277 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id={4220277}
              data-element_type="section"
              data-settings='{"_ha_eqh_enable":false}'
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-5a83622"
                  data-id="5a83622"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-fc1ced0 elementor-widget elementor-widget-text-editor"
                      data-id="fc1ced0"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <style
                          dangerouslySetInnerHTML={{
                            __html:
                              "\n                                                /*! elementor - v3.22.0 - 26-06-2024 */\n                                                .elementor-widget-text-editor.elementor-drop-cap-view-stacked .elementor-drop-cap {\n                                                    background-color: #69727d;\n                                                    color: #fff\n                                                }\n\n                                                .elementor-widget-text-editor.elementor-drop-cap-view-framed .elementor-drop-cap {\n                                                    color: #69727d;\n                                                    border: 3px solid;\n                                                    background-color: transparent\n                                                }\n\n                                                .elementor-widget-text-editor:not(.elementor-drop-cap-view-default) .elementor-drop-cap {\n                                                    margin-top: 8px\n                                                }\n\n                                                .elementor-widget-text-editor:not(.elementor-drop-cap-view-default) .elementor-drop-cap-letter {\n                                                    width: 1em;\n                                                    height: 1em\n                                                }\n\n                                                .elementor-widget-text-editor .elementor-drop-cap {\n                                                    float: left;\n                                                    text-align: center;\n                                                    line-height: 1;\n                                                    font-size: 50px\n                                                }\n\n                                                .elementor-widget-text-editor .elementor-drop-cap-letter {\n                                                    display: inline-block\n                                                }\n                                            "
                          }}
                        />
                        <p>
                          <a href="https://web.archive.org/web/20240120183841/https://motortiger.com/">
                            <b>Motor Tiger</b>
                          </a>
                          &nbsp;understands that using and sharing your information is
                          vital to you. Motor Tiger wants to make you feel secure and
                          comfortable doing business with us as part of our dedication
                          to customer service. Here are some standards that Motor
                          Tiger adheres to when it comes to gathering and using your
                          information, including your Personal Information and our
                          efforts to keep it private. Motor Tiger retains the right to
                          change this Privacy Statement at its sole discretion.
                        </p>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-d2c38d7 elementor-widget elementor-widget-text-editor"
                      data-id="d2c38d7"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          This Privacy Statement explains how we collect, use,
                          protect, and disclose your information when you visit and
                          website at&nbsp;
                          <a href="https://web.archive.org/web/20240120183841/https://motortiger.com/">
                            https://motortiger.com/
                          </a>
                          , across the United States, or when you use any other
                          services. Then this Privacy Statement also educates you
                          about specific options and rights you have in relation to
                          your data and how to control your data privacy.
                        </p>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-b064043 elementor-widget elementor-widget-text-editor"
                      data-id="b064043"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          Please keep in mind that this Privacy Statement does not
                          apply to the practices of other parties, such as our
                          partners, third-party service providers, and/or advertising,
                          even if such services are branded as or delivered on behalf
                          of Motor Tiger. Other entities’ privacy rules govern
                          information collected from you by others, such as
                          third-party websites that you access through links on the
                          Website. Please read the privacy rules of such third parties
                          carefully.
                        </p>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-76dda73 elementor-widget elementor-widget-text-editor"
                      data-id="76dda73"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          The Motor Tiger Websites’ data gathering and usage methods
                          are substantially identical to how Motor Tiger obtains
                          customer information when you visit the website. However,
                          there may be variations between how the App collects and
                          uses your information and how websites or stores gather and
                          use your information. These distinctions will be highlighted
                          throughout the policy.
                        </p>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-588b67e elementor-widget elementor-widget-heading"
                      data-id="588b67e"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h2 className="elementor-heading-title elementor-size-default">
                          We Gather Information:
                        </h2>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-8bd3a47 elementor-widget elementor-widget-text-editor"
                      data-id="8bd3a47"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          To deliver and enhance our Services, Motor Tiger may gather
                          personal information about you. The kinds of personal
                          information Motor Tiger may have collected in the previous
                          twelve months, and the sources from which that information
                          may have been obtained are described below.
                        </p>
                        <p>
                          <b>“Personal Information”</b>&nbsp;refers to data that
                          identifies, relates to, describes, is fairly capable of
                          being associated with, may be reasonably linked to, or could
                          be used to directly or indirectly identify a specific person
                          or household (or from those and other information either in
                          our possession or likely to come into our possession). If
                          that information may be used to identify you, your home, or
                          your device, it may also include additional information
                          related to your Personal Information, such as Generic
                          Information (defined below), location, preferences, or
                          interests.
                        </p>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-dfa9478 elementor-widget elementor-widget-heading"
                      data-id="dfa9478"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h2 className="elementor-heading-title elementor-size-default">
                          Business Information:
                        </h2>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-be38280 elementor-widget elementor-widget-text-editor"
                      data-id="be38280"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          Motor Tiger is a business-to-business solution that assists
                          our commercial customers in meeting their needs. As a
                          result, we gather a lot of information from our clients
                          about their businesses, such as their company’s name,
                          address, zip code, phone number, email address, financial
                          account information to enable transactions, vehicle details,
                          and other business-related information. Additionally, to
                          fulfill an order or inquiry, Motor Tiger may need to collect
                          information about an individual’s role within the company,
                          such as the individual’s name, title, location, phone
                          number, email address, other contact information,
                          information related to a “Motor Tiger” Account with the
                          Website, and other information.
                        </p>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-0bce31e elementor-widget elementor-widget-heading"
                      data-id="0bce31e"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h2 className="elementor-heading-title elementor-size-default">
                          Personal Information:
                        </h2>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-539bcd6 elementor-widget elementor-widget-text-editor"
                      data-id="539bcd6"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          When you use our Services, we may collect the following
                          “Personal Information” about you: your name, address, zip
                          code, phone number, email address, gender, age, date of
                          birth, and information about your vehicle (such as your
                          Vehicle Identification Number (“VIN”) and year). When you
                          buy from our website, Motor Tiger may collect your credit
                          card information and billing address; however, your payment
                          card information is securely transmitted to our payment card
                          processor and is not held by Motor Tiger. When you create a
                          personal “Account” with the Websites or a “My Account”
                          account inside the Apps, we will also collect your email
                          address and a specific password. We may also gather data and
                          information about your location.
                        </p>
                        <p>
                          Generic Information may include data about Website pages
                          visited and visit length, App usage, device information,
                          your IP address, browser or operating system information, or
                          other information about your contact with our Websites or
                          Apps. Generic Information may be used or combined in ways
                          that identify you, your firm, or your position within it in
                          some circumstances. In some cases, the information will be
                          classified as either Business Information or Personal
                          Information, depending on the circumstances.
                        </p>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-e4b7fc2 elementor-widget elementor-widget-heading"
                      data-id="e4b7fc2"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h2 className="elementor-heading-title elementor-size-default">
                          Cookies and Tracking Data:
                        </h2>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-3e27bf9 elementor-widget elementor-widget-text-editor"
                      data-id="3e27bf9"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          The Websites and Apps may utilize third-party goods and
                          services, such as cookies and web beacons, to collect
                          anonymous traffic data. A cookie is a little bit of data
                          kept on your device that aids in recognition of you by
                          websites, apps, and various servers. Other tracking
                          technologies, such as pixels or transparent GIF files, may
                          be used by Motor Tiger and its third-party service providers
                          for app and website administration and user tracking.
                        </p>
                        <p>
                          Some of the cookies we employ are “strictly required” for
                          our Websites and Apps to function properly. Others add to
                          the operation of our websites and apps but aren’t
                          necessarily required. Some cookies help us enhance the
                          functionality of our Websites and Apps (for example, by
                          collecting analytic data), while others help us offer you
                          personalized services (like ads that you may be interested
                          in).
                        </p>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-015452d elementor-widget elementor-widget-heading"
                      data-id="015452d"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h2 className="elementor-heading-title elementor-size-default">
                          We use the following types of cookies:
                        </h2>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-23d4494 elementor-widget elementor-widget-text-editor"
                      data-id="23d4494"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          <b>Session Cookies</b>&nbsp;that are only used during a
                          certain session. Session Cookies are used to run our
                          Services. Session cookies are only used for a limited time
                          and are automatically removed when you exit your browser
                        </p>
                        <p>
                          <b>Preference Cookies&nbsp;</b>are used to remember your
                          preferences and settings. Preference cookies are first-party
                          cookies that stay on your computer or device until you
                          delete them or until their expiration date.
                        </p>
                        <p>
                          <b>Cookies from third parties.</b>Motor Tiger allows
                          third-party service providers, marketers, and other
                          businesses to utilize cookies and similar technologies on
                          our website. These firms may acquire information about your
                          use of our Apps, Websites, and other online services over
                          time and across multiple services and track your activity on
                          our Websites or Apps. Furthermore, some firms may use the
                          information they gather to display targeted advertisements
                          on our or other companies’ behalf, including other apps,
                          websites, or online services. We are not responsible for the
                          operation of cookies or other technologies installed on your
                          device by third parties.
                        </p>
                        <p>
                          <b>Transparent GIFs</b>, Pixel Tags, and Web Beacons Pixel
                          tags and web beacons are little visual images placed on the
                          app or website pages or in our emails to let us know if you
                          have taken a certain action. The pixel tags and web beacons
                          create a notification when you view these pages or open or
                          click an email. These tools enable us to track how well our
                          communications are received and enhance our web pages.
                        </p>
                        <p>
                          <b>Other Technologies:</b>
                        </p>
                        <p>
                          To improve our website’s quality and the services we
                          provide, we gather a variety of information from other
                          technologies. For example, we may collect Usage Data and
                          other information about the device you use to access our
                          Apps and Websites, as well as information about your
                          operating system and/or mobile device type, browser type,
                          domain, and other system settings, as well as the language
                          your system uses and the country and time zone where your
                          device is located. The IP address of the device you use to
                          connect to the Internet may be recorded by us.
                        </p>
                        <p>
                          <b>Cookie Selections:</b>
                        </p>
                        <p>
                          You have complete control over how you wish to use or allow
                          cookies to be used on your devices. You may use your browser
                          or mobile device settings to reject or refuse all cookies,
                          get a notification when a cookie is delivered, or limit
                          otherwise which cookies your browser or mobile device
                          accepts. You may also change your settings and erase any
                          cookies currently saved on your device. To learn how to
                          control the placement and/or removal of cookies and other
                          technologies, check the instructions supplied by your
                          browser or mobile device maker. Limiting or blocking the use
                          of cookies and other technologies, on the other hand, may
                          limit or prevent you from performing some transactions,
                          using certain activities, or accessing certain information
                          on our Website.
                        </p>
                        <p>
                          Motor Tiger shares non-personally identifiable Generic
                          Information about website users with third parties to
                          monitor cross-device interaction and targeted advertising,
                          including on other websites. Motor Tiger accomplishes this
                          by combining cookie data with web beacons. When you visit
                          and interact with the Websites, Motor Tiger may also utilize
                          third-party organizations to offer advertising services
                          and/or collect certain information. During your visit to the
                          Websites and/or other websites, these third-party companies
                          may collect and use non-personally identifiable Generic
                          Information (click stream information, browser type, time
                          and date, subject of advertisements clicked or scrolled
                          over) to provide advertisements about goods and services
                          likely to be of greater interest to you.
                        </p>
                        <p>
                          These third-party firms may use cookies and other
                          technologies to identify your browser to collect and store
                          information about your online browsing behavior, including
                          your websites and apps’ activities. You can opt-out of
                          having non-personal information or cookies used to target
                          adverts to you by the third-party service providers and
                          altering your browser or device’s cookie settings. These
                          third-party firms may use cookies and other technologies to
                          identify your browser to collect and store information about
                          your online browsing behavior, including your websites and
                          apps’ activities. You can opt-out of having non-personal
                          information or cookies used to target adverts to you by the
                          third-party service providers and altering your browser or
                          device’s cookie settings.
                        </p>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-b0df1c9 elementor-widget elementor-widget-text-editor"
                      data-id="b0df1c9"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          <b>Personal Data Collected in the Previous 12 Months</b>
                        </p>
                        <p>
                          Over the previous 12 months, Motor Tiger has not gathered
                          any additional sorts of Personal Information from our
                          customers and visitors.
                        </p>
                        <p>
                          <b>How Do We Gather Information About You?</b>
                        </p>
                        <p>
                          Motor Tiger obtains your information in various ways,
                          including information you provide, the information we
                          acquire from your use of our Services, such as our Websites
                          and Apps, and information we obtain from third parties.
                        </p>
                        <p>
                          <b>Information You Provide:</b>&nbsp;We gather the
                          information you choose to share. To utilize some elements of
                          our Apps and Websites, complete your requests with us, or
                          offer you certain Services, we may ask you to give certain
                          information – including Personal Information. When you
                          purchase auto parts and accessories from our Websites, we
                          will ask for your name, address, and credit card
                          information. When you approach us with a question or remark,
                          we may ask for your name, email address, or other contact
                          information. If you make an account with us, we may ask you
                          to submit your name, email address, and phone number and
                          create a password. If you opt to join our mailing list, you
                          will be asked to submit your email address. Motor Tiger will
                          primarily gather Business Information to fulfill orders
                          placed by business clients.
                        </p>
                        <p>
                          <b>Data Collected When You Use Our Services:</b>&nbsp;We get
                          specific information about you via your use of our Services,
                          such as Website and other generic information. For example,
                          we may collect information about the device you use to log
                          into, access, and utilize our Websites when you use them.
                          Other Generic Information on how you use our Websites, Apps,
                          or other Services may be collected.
                        </p>
                        <p>
                          When you use our Website, we may ask for your location
                          information to give nearby store locations and certain App
                          features and Services. You can prevent location tracking,
                          but if you do not disclose your location, some features of
                          the Websites and Apps will not work properly.
                        </p>
                        <p>
                          <b>Additional Generic Information:</b>&nbsp;We may use other
                          Generic information, such as aggregate statistics, about how
                          you use our Websites, Apps, and other Services.
                        </p>
                        <p>
                          <b>Other:</b>&nbsp;We collect generic network information to
                          ensure optimal Website and App functioning improvement.
                        </p>
                        <p>
                          <b>Camera, Photos, and Media Files:</b>&nbsp;You may upload
                          photos and images from your smartphone to the Apps as part
                          of your experience. The Apps may need to access or alter
                          your camera, photo gallery, or other areas of your device
                          that store media files to do so.
                        </p>
                        <p>
                          <b>Phone and Contacts:&nbsp;</b>The Apps may ask for access
                          to your contacts on your smartphone. It may also need to use
                          the phone functionalities on your smartphone to make direct
                          calls and read phone status and identification.
                        </p>
                        <p>
                          <b>
                            Information We Collect from Other Sources / Third Parties:
                          </b>
                          &nbsp;We may collect information about you from third
                          parties that assist us in providing our Services. Our order
                          fulfillment and shipping partners, for example, may provide
                          us with information regarding your order or product return.
                          We may also gather information from our marketing partners
                          to provide you with information about items we believe you
                          might be interested in. Finally, we may collect information
                          about you, such as Generic Information and Business
                          Information, that does not directly identify you but is used
                          in a way that might turn it into Personal Information. For
                          example, a part manufacturer or distributor may provide
                          Motor Tiger warranty or product recall information about a
                          product you purchased from us. To offer you associated
                          services, we may combine that generic information with your
                          information in our national warranty database or other
                          systems.
                        </p>
                        <p>
                          <b>
                            How We Collect Information for Business and Other Purposes
                          </b>
                        </p>
                        <p>
                          Motor Tiger collects, processes, and utilizes your
                          information to provide you with Motor Tiger’s Services. As a
                          result, we acquire information about you for a variety of
                          reasons, including:
                        </p>
                        <ul>
                          <li>
                            To carry out a contract with you, such as processing and
                            completing your Motor Tiger orders placed on our website,
                            through our apps, or in one of our stores.
                          </li>
                          <li>
                            When you sign up for the Motor Tiger mailing list, or for
                            a “My Account” or a “Motor Tiger” account and choose to
                            receive special offers, promotions, news, surveys, and
                            correspondence from Motor Tiger Rewards, or when you sign
                            up for the Motor Tiger mailing list.
                          </li>
                          <li>
                            To make our business goals in connection to the services
                            we serve you easier. These operational reasons may
                            include, but are not limited to: performing duties
                            relating to the operation of our Services, such as our
                            Websites and Apps, such as ad placement and/or providing
                            personalized content to our users
                          </li>
                          <li>
                            Maintenance and improvement of our Services, including the
                            Websites and Apps; detection of security events; and
                            debugging and correcting faults that cause our Websites,
                            Apps, or other Services to malfunction.
                          </li>
                        </ul>
                        <p>
                          <strong>
                            Other than that, the collection is linked to offering our
                            Services to you. For example, we may gather the following
                            information about you:
                          </strong>
                        </p>
                        <ul>
                          <li>
                            To enable you to interact with interactive parts of our
                            Services, such as our online “Chat Now!” tool.
                          </li>
                          <li>
                            To serve you, our fellow members, customers, and visitors
                            with customer service.
                          </li>
                          <li>
                            To obtain important data or analysis to improve our
                            services.
                          </li>
                          <li>To keep track of how our services are being used.</li>
                          <li>
                            To identify, prevent, and resolve technological problems.
                          </li>
                          <li>
                            To assist you in locating Motor Tiger Stores in your area.
                          </li>
                        </ul>
                        <p>
                          Unless you have opted not to receive such information, we
                          will send you news (for example, via a newsletter), special
                          offers, marketing or promotional materials, and general
                          information about other goods, services, and events that we
                          offer that are similar to those that you have already
                          purchased or enquired about, or that we believe may be of
                          interest to you. You can opt-out of receiving any or all of
                          these communications from us by contacting us at the address
                          below, or by clicking on the “unsubscribe” links in the
                          email messages.
                        </p>
                        <p>
                          To present you with personalized content on the Websites and
                          in email communications sent in conjunction with your use of
                          the Websites, such as ads tailored to your demographics,
                          interests, preferences, and purchase history.
                        </p>
                        <p>
                          We may also use “automatically collected” information and
                          “cookie” information to: personalize our services, such as
                          remembering your information, so you don’t have to re-enter
                          it during your visit or the next time you visit the Websites
                          or Apps; provide customized third-party advertisements,
                          content, and information; monitor and analyze our
                          effectiveness and third-party marketing activities; monitor
                          aggregate usage metrics such as total number of visitors,
                          pages viewed, and time spent on the Websites or Apps; and
                          monitor aggregate usage metrics.
                        </p>
                        <p>
                          <b>How We Share and Disclose Your Information</b>
                          <br />
                          <b>Why Do We Share Your Information?</b>
                        </p>
                        <p>
                          Motor Tiger may share customer Personal Information with
                          third parties that supply Motor Tiger with services and
                          products. The following are just a few examples of how your
                          information might be used:
                        </p>
                        <ul>
                          <li>
                            Purchase fulfillment – for example, we’ll give the firms
                            that assist us to send your order to you. your name,
                            company name, and address. Information may also be shared
                            with our product providers.
                          </li>
                          <li>
                            Motor Tiger Gift Cards and Motor Tiger Merchandise Credits
                            can be redeemed.
                          </li>
                          <li>
                            Motor Tiger Rewards and other customer reward programs are
                            supported.
                          </li>
                          <li>
                            Direct mail and e-mail marketing are examples of marketing
                            activity.
                          </li>
                          <li>Cleaning, upkeep, and analysis of databases.</li>
                          <li>Improving the customer experience.</li>
                          <li>Management of warranties.</li>
                          <li>
                            To investigate, safeguard against, and assist in
                            prosecuting people involved in or impacting Motor Tiger,
                            our Services, and/or our customers for harmful, deceptive,
                            fraudulent, or unlawful activities. Disclosures to law
                            enforcement, prosecutors, and other agencies may be made
                            in order to investigate possible criminal behavior or
                            other civil infractions. In response to a valid and
                            enforceable request by law enforcement, judicial, or other
                            public authorities, or in conjunction with an appropriate
                            legal duty.
                          </li>
                        </ul>
                        <p>
                          Motor Tiger also collects, retains, and utilizes aggregate
                          data, such as demographics and statistical data, that does
                          not contain Personal Information. Third parties may access
                          and use this aggregate data to help Motor Tiger and its
                          suppliers better understand and serve our customers.
                        </p>
                        <p>
                          Motor Tiger participates in the Adobe Marketing Cloud Device
                          Co-op to better understand how you use our Websites and Apps
                          across many platforms and provide personalized promotions.
                        </p>
                        <p>
                          There are two types of third parties who get personal
                          information: We share or otherwise disclose personal
                          information about persons and businesses with the following
                          kinds of third parties. Certain third parties have access to
                          your information only to carry out these duties on our
                          behalf, and they are prohibited from disclosing or using it
                          for any other purpose:
                        </p>
                        <p>
                          <b>Service / Fulfillment Providers:</b>&nbsp;To support and
                          help us provide our Services to you, we use third-party
                          fulfillment, shipment, transportation, and/or delivery
                          providers, organizations, persons, and agents under contract
                          with Motor Tiger (“Service Providers”). Such Service
                          Providers assist us in assessing how our Services are used
                          or provided by performing activities or functions on our
                          behalf, providing fulfillment and other services, or
                          performing duties or functions on our behalf. For example,
                          to execute your orders with Motor Tiger, we will share your
                          name and address with product suppliers and delivery firms.
                          We supply our payment card processors with the credit card
                          information you submit to use in-store or online to fulfill
                          your order.
                        </p>
                        <p>
                          Your account information is shared with service providers
                          that assist us in running our Motor Tiger Rewards and other
                          customer reward programs. We also share data with database
                          and cloud storage companies that assist us in maintaining
                          our Website and other services.
                        </p>
                        <p>
                          <b>Other Motor Tiger Entities:</b>&nbsp;Your information may
                          be shared or disclosed with other Motor Tiger entities.
                        </p>
                        <p>
                          <b>Partners in Marketing:</b>&nbsp;We may also share your
                          information with our marketing partners from time to time to
                          offer you information about our Services, such as promotions
                          or coupons. This information is often anonymized to not
                          directly identify you; nevertheless, on occasion, we may
                          share your Personal Information with such Marketing
                          Partners.
                        </p>
                        <p>
                          <b>Type of data which you provide us:</b>
                        </p>
                        <ul>
                          <li>Your name, customer Ids</li>
                          <li>
                            Contact information (Phone number, mailing /physical
                            address)
                          </li>
                          <li>Purchase history</li>
                          <li>Rewards, coupons</li>
                          <li>Cookies, usage data, IP address</li>
                          <li>Other information you choose to provide us</li>
                        </ul>
                        <p>
                          The data you provide us is used to provide service and give
                          to Motor Tiger’s service providers, Marketing partners, and
                          other motor tiger entities.
                        </p>
                        <p>
                          <b>
                            Personal Information Disclosed for Business Purposes
                            Categories:&nbsp;
                          </b>
                          Motor Tiger is a business-to-business solution for our
                          corporate clients, not for individuals. As a result, the
                          bulk of information given is your Business Information or
                          Generic Information related to your function at work. We may
                          also disclose your Personal Information for the
                          above-mentioned business objectives. Most importantly, we
                          must share your name, address, payment information, the
                          items you have requested to purchase, and any other
                          information related to your product order with those
                          Fulfillment Providers (our payment card processor and our
                          shipment, transportation, and/or delivery providers) who are
                          required to complete your order.
                        </p>
                        <p>
                          To manage our Website, provide you with advertisements or
                          other marketing, or provide additional services, we may need
                          to disclose certain Generic Information, such as your IP
                          address and/or browser information. When Business
                          Information or Generic Information is used in a way that
                          properly identifies or links you to you, it is considered
                          Personal Information.
                        </p>
                        <p>
                          <b>Personal Information Categories Sold:</b>&nbsp;Motor
                          Tiger does not sell, rent, or lease any of its customers’
                          personal or business information to third parties. Motor
                          Tiger does not sell personal information about children
                          under the age of sixteen.
                        </p>
                        <p>
                          Please keep in mind that a “sale” of Personal Information
                          does not include situations in which such information is
                          shared as part of a merger, acquisition, or other
                          transaction involving all or part of our company. We may
                          transmit your Personal Information to a third party as part
                          of a merger or other business transaction if we sell all or
                          part of our business, make a sale or transfer of assets, or
                          are otherwise involved in a merger or other business
                          transaction. If such a transaction significantly impacts how
                          your Personal Information is processed, we will tell you
                          before it is implemented.
                        </p>
                        <p>
                          <b>Data Retention</b>
                        </p>
                        <p>
                          Motor Tiger will keep your Business Information and Personal
                          Information for as long as is required for the reasons
                          stated in this Privacy Statement. We will keep and use your
                          Personal Information to the extent necessary to comply with
                          our legal obligations (for example, if we are required by
                          applicable laws to keep your data), resolve disputes, and
                          enforce our legal agreements and policies, as well as for
                          other commercial, retail, and/or marketing purposes.
                        </p>
                        <p>
                          <b>Data Transfer</b>
                        </p>
                        <p>
                          Individuals in the United States of America are welcome to
                          use Motor Tiger’s services. While our Websites and Apps are
                          open to everyone interested in Motor Tiger, we do not sell
                          or make any products, goods, or other services available to
                          anybody outside of the United States, including the European
                          Union. Your data, including Personal Information, may be
                          transmitted to and stored on computers outside your state,
                          province, country, or other governmental jurisdiction, where
                          data protection regulations may differ from those in your
                          jurisdiction.
                        </p>
                        <p>
                          If you choose to give information to us from outside the
                          United States, please be aware that we will transmit and
                          handle your data, including Personal Information, in the
                          United States. If you live in the European Union, you should
                          be informed that the United States’ data protection rules
                          are not considered as strong as those in the EU. Your
                          submission of such information implies your approval to that
                          transfer.
                        </p>
                        <p>
                          <b>Data Protection</b>
                        </p>
                        <p>
                          We care about the security of your information but keep in
                          mind that no method of Internet transmission or computer
                          storage is entirely safe. While we endeavor to safeguard
                          your Personal Information against loss, misuse, and
                          unauthorized access, modification, disclosure, and
                          destruction using commercially reasonable techniques, we
                          cannot guarantee its ultimate security. By using our
                          Websites, Apps, and Services, you acknowledge that the use
                          of the Internet has inherent data security and privacy
                          limitations and that the security, integrity, and privacy of
                          any and all information exchanged between you and Motor
                          Tiger or between you and other related entities, cannot be
                          guaranteed.
                        </p>
                        <p>
                          We cannot guarantee or assure the security of any
                          information you send us or store, and you do so at your own
                          risk.
                        </p>
                        <p>
                          Any transactions you make with Motor Tiger, including those
                          made through our Websites and Apps, are processed by
                          third-party payment processors. The payment processors’
                          privacy statements and security procedures govern the
                          handling of those transactions. Motor Tiger is not
                          responsible for the data security procedures of third-party
                          payment processors.
                        </p>
                        <p>
                          <b>
                            “Do Not Track” Policy CalOPPA (California Online Privacy
                            Protection Act) signals.
                          </b>
                        </p>
                        <p>
                          Do Not Track (“DNT”) is not something we support. Do Not
                          Track is a browser setting that lets websites know you don’t
                          want to be monitored. You may enable or disable Do Not Track
                          by going to your browser’s Preferences or Settings page; you
                          may enable or disable Do Not Track. Consumers’ online
                          activity may be tracked over time and across third-party
                          Websites or online services. As we discussed previously, you
                          may update your browser’s settings to change its acceptance
                          of tracking technology.
                        </p>
                        <p>
                          Third parties may acquire information about you. Third-party
                          reactions to do-not-track signals or other similar methods
                          are beyond our control. Third parties use of data about you
                          and their separate privacy rules regulate their response to
                          do-not-track signals.
                        </p>
                        <p>
                          <b>Your Privacy Rights in California</b>
                        </p>
                        <p>
                          Under California law, residents have various rights
                          regarding their personal information. Motor Tiger seeks to
                          take reasonable efforts to allow California residents to
                          access, correct, modify, delete, or restrict the use of
                          their Personal Information and exercise other legal rights.
                          Individuals may be entitled to the following benefits under
                          applicable legislation, according to Motor Tiger:
                        </p>
                        <ul>
                          <li>
                            Right to Access / Disclosure: to have access to your
                            Personal Information upon simple request – that is, you
                            may acquire a copy of such data, as well as other
                            information relevant to the collection or processing,
                            following receipt of a verified request.
                          </li>
                          <li>
                            Direct Marketer Disclosure: to have access to the
                            categories, names, and addresses of third parties who have
                            obtained Personal Information for direct marketing
                            purposes upon simple request and free of charge. For
                            further information, check the “Direct Marketers
                            Disclosure” section below.
                          </li>
                          <li>
                            Obtaining a list of The particular elements of your
                            Personal Information held by Motor Tiger
                          </li>
                          <li>
                            Personal Information about you that has been collected,
                            sold to third parties, or shared to third parties for
                            commercial reasons
                          </li>
                        </ul>
                        <p>
                          <b>
                            Personal Information categories sold in the last 12
                            months;
                          </b>
                        </p>
                        <p>
                          The categories of third parties with whom Personal
                          Information is shared, sold, or disclosed for a business
                          purpose; the business or commercial purpose for collecting
                          or selling Personal Information; and the categories of third
                          parties with whom Personal Information is shared, sold, or
                          disclosed for a business purpose.
                        </p>
                        <p>
                          <b>Right to Opt-Out of Personal Information Sales:&nbsp;</b>
                          Under the California Consumer Privacy Act (“CCPA”),
                          California individuals have the right to refuse the sale of
                          their personal information in certain circumstances.
                          However, as previously stated, Motor Tiger does not sell
                          personal information.
                        </p>
                        <p>
                          <b>Right to Deletion / “Right to be Forgotten”:</b>&nbsp;You
                          have the right to have your Personal Information deleted in
                          certain circumstances outlined by relevant data protection
                          law and upon receipt of a verified request. Right to Data
                          Portability: You have the right to request that we send your
                          Personal Information directly to a third-party processor of
                          your choice (where technically feasible; may be limited to
                          situations when processing is based on your consent).
                        </p>
                        <p>
                          <b>Right to Non-Discrimination:&nbsp;</b>You have the right
                          to non-discrimination in the Services or quality of Services
                          you get from us for exercising your rights, as defined by
                          applicable law.
                        </p>
                        <p>
                          To exercise these rights, please contact us using the
                          information in the “Contact Us” section below. Before
                          responding to such inquiries, we may require you to verify
                          your identity.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-125464d elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="125464d"
              data-element_type="section"
              data-settings='{"_ha_eqh_enable":false}'
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d91ddd3"
                  data-id="d91ddd3"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-348849b elementor-widget elementor-widget-text-editor"
                      data-id="348849b"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          <b>Motor Tiger’s Reward Programs</b>
                        </p>
                        <p>
                          Individuals who participate in our “Motor Tiger Rewards”
                          rewards programs (collectively, “Rewards Programs”) get
                          discounts and other advantages. You may make purchases to
                          earn credits and savings on future purchases when you sign
                          up for one of our Rewards Programs. We choose and customize
                          coupons, promotions, and other discounts or offers based on
                          what you buy and the stores and e-commerce platforms you
                          use. By registering for the program, you agree to allow us
                          to utilize your information to find the most appropriate
                          coupons, promotions, and other discounts or offers for you.
                        </p>
                        <p>
                          We use the information we collect on our Motor Tiger Rewards
                          Program members to provide targeted incentives and value to
                          our customers, which helps us build relationships with them
                          and improve their entire experience. The value we pass on to
                          you through our Rewards program and other incentives is not
                          based on the value of the data you supply to us in any
                          manner. Other than providing you with your Rewards,
                          advantages, and other incentives, Motor Tiger does not use
                          your information for its reasons.
                        </p>
                        <p>
                          Our Rewards Programs are entirely optional. You can opt-out
                          of Rewards Programs after enrolling by logging into your
                          account or contacting us using the details provided below.
                          While we will not penalize you for exercising your CCPA
                          rights, we may be unable to give you tailored coupons,
                          promotions, or other discounts or offers if you request the
                          deletion of your personal information linked with your
                          Rewards Program account. We may no longer be able to
                          distribute or share customized coupon mailers or
                          personalized digital offers with you, for example.
                        </p>
                        <p>
                          <b>Disclosures for Direct Marketers</b>
                        </p>
                        <p>
                          In addition to the rights set out above, if you are a
                          California resident, you have the right to seek information
                          from us about how we share certain categories of Personal
                          Information with third parties for their direct marketing
                          purposes. You have the right under California law to send us
                          a request for the following information at the address
                          stated below:
                        </p>
                        <ul>
                          <li>
                            The kind of information we sent to third parties for
                            direct marketing reasons in the previous calendar year
                          </li>
                          <li>
                            The names and addresses of the third parties who got the
                            information; and examples of the items or services
                            advertised if the nature of the third party’s company
                            cannot be ascertained from their name.
                          </li>
                        </ul>
                        <p>
                          Please submit enough information for us to evaluate if this
                          applies to you and attest to the fact that you are a
                          California resident to make such a request. For our answer,
                          please include a 6000 Big Pine Dr, Fontana, CA 92336
                          address. You can write to us at the address given to make
                          this request. Any such request must begin with the phrase
                          “California Privacy Rights Request” and contain your name,
                          street address, city, state, and ZIP code. Please note that
                          we are only obligated to reply to one request per customer
                          per year, and we are not compelled to respond to requests
                          sent to the address or toll-free number shown below.
                        </p>
                        <p>
                          It’s worth noting that responsive material may come in a set
                          format that isn’t tailored to you.
                        </p>
                        <p>
                          <b>Your Options</b>
                        </p>
                        <p>
                          While Motor Tiger encourages you to use the personalized
                          features available on the Websites, you can access the
                          majority of Motor Tiger’s online services without
                          registering. You may unsubscribe from the Motor Tiger
                          mailing list at any time by clicking “unsubscribe” in the
                          Motor Tiger emails that are delivered to your email address.
                          You may modify your profile at any moment to change your
                          information. You can unsubscribe from motor Tiger
                          promotional marketing emails by visiting Motor Tiger.com,
                          calling +1(888) 778 4437, or writing to the following
                          address:
                        </p>
                        <p>
                          <b>6000 Big Pine Dr, Fontana, CA 92336</b>
                        </p>
                        <p>
                          <b>Other Websites’ Links</b>
                        </p>
                        <p>
                          The Websites and Apps of Motor Tiger may contain links to
                          other websites or services that we do not maintain. This
                          Privacy Statement does not apply to third-party websites
                          that may be connected to our Websites or Apps. Even though
                          such services are branded as, or delivered on behalf of,
                          Motor Tiger, this Privacy Statement does not regulate the
                          actions of third parties, such as our partners, third-party
                          service providers, and/or advertising. Motor Tiger has no
                          control over or responsibility for the security or privacy
                          of those sites. Motor Tiger recommends that you read the
                          privacy policies on those sites.
                        </p>
                        <p>
                          <b>Privacy of Children</b>
                        </p>
                        <p>
                          All of our Services, including our Websites and Apps, are
                          aimed at adults and are not intended for children under the
                          age of 18 (“Children”). As a result, children under the age
                          of 18 are not permitted to access our Websites or Apps. If
                          you are under the age of 18, do not attempt to register for
                          or use any of our Services, including our Websites and Apps,
                          or supply us with any Personal Information.
                        </p>
                        <p>
                          We do not collect Personal Information from children under
                          the age of 18. Please notify us if you are a parent or
                          guardian and believe your kid has violated this Privacy
                          Statement by providing us with Personal Information. If we
                          learn that we have obtained Personal Information from
                          children without parental consent, we will take measures to
                          erase the data from our systems.
                        </p>
                        <p>
                          <b>Changes to this Privacy Statement</b>
                        </p>
                        <p>
                          Motor Tiger reserves the right to change this Privacy
                          Statement at any moment. Motor Tiger will notify you of any
                          major changes to its Privacy Statement by revising the
                          Privacy Statement modification date above and displaying the
                          changes on this website. Motor Tiger encourages you to visit
                          this website for changes on a regular basis.
                        </p>
                        <p>
                          <b>Providing Motor Tiger with a Verifiable Request</b>
                        </p>
                        <p>
                          As previously stated, California citizens have specific
                          rights to access, remove, or otherwise restrict their
                          information’s use, acquisition, and/or distribution. Motor
                          Tiger will react to a “verifiable request” from an
                          individual to exercise his or her rights under such laws –
                          that is, where Motor Tiger receives a request purporting to
                          be from a specific individual and Motor Tiger is able to
                          authenticate the subject’s identification. The necessity to
                          authenticate an individual’s identification is vital for
                          protecting your information and ensuring that it is not
                          shared with someone posing as you or acting on your behalf
                          who is not allowed to do so.
                        </p>
                        <p>
                          You may make a verified request using our website, or the
                          toll-free number indicated below in the “How to Contact Us
                          for CCPA Requests” section, or as otherwise stated on our
                          Websites and Apps (if such means are available). As part of
                          the process, Motor Tiger will ask you for personal
                          information so that we can verify your identification. This
                          information might include your name, address, account
                          information, and any other information Motor Tiger deems
                          essential to fairly authenticate your identification and
                          prevent your information from being shared with someone
                          impersonating you. We will work quickly to fulfill your
                          request after confirming your identification.
                        </p>
                        <p>
                          Please keep in mind that there may be times when we are
                          unable to complete your request, such as when we are unable
                          to locate any information on you inside your systems. In
                          some cases, such as when your information is required to
                          fulfill your order with us or to comply with a legal
                          requirement, we may not be able to comply with your deletion
                          request. We’ll let you know whether we can accommodate your
                          request for rights.
                        </p>
                        <p>
                          If we have trouble establishing your identity, we may ask
                          for more information. In the event that we are unable to
                          authenticate your identity, we will not release your
                          information or honor other requests. A consumer can appoint
                          an “authorized agent” under California law to make certain
                          verified requests on their behalf, such as the right to know
                          what information we gather about them or the right to have
                          their information deleted. We will ask you to identify and
                          provide written consent for such people to serve as your
                          authorized agent and exercise your applicable rights under
                          California law in such cases since the security and privacy
                          of your information is vital. This may necessitate us
                          contacting you directly to warn you that someone claiming to
                          be your agent is attempting to access or delete your data.
                        </p>
                        <p>
                          We will also independently verify your identification to
                          guarantee that no one else is impersonating you and
                          exercising your rights without your permission. If you
                          cannot or will not obtain authorization in writing for an
                          identified authorized agent to act on your behalf, or if we
                          cannot independently authenticate your identity, we will not
                          release your information or satisfy any other requests.
                        </p>
                        <p>Contact Information for CCPA Requests.</p>
                        <p>
                          Please contact Motor Tiger if you have any concerns
                          regarding this Privacy Policy, the practices of this site,
                          or your interactions with this site:
                        </p>
                        <p>
                          Website:
                          <a href="https://web.archive.org/web/20240120183841/https://motortiger.com/">
                            &nbsp;https://motortiger.com/
                          </a>
                        </p>
                        <p>
                          Call Us at
                          <a href="https://web.archive.org/web/20240120183841/tel:(855) 253-1634">
                            : +1 (855) 253-1634
                          </a>
                        </p>
                        <p>
                          <b>Having trouble finding our privacy policy?</b>
                        </p>
                        <p>
                          Individuals with disabilities who cannot access our privacy
                          statement online may contact us at the above-mentioned
                          address to inquire about obtaining a copy of our Privacy
                          Statement in a more readily visible format.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        {/* #page */}
      </div>
    </div>
  );
};

export default PrivacyPolicy;